import { Box } from '@mui/material';

const Dashboard = () => {
  return <Box sx={{ padding: 4 }}></Box>;
};

export default Dashboard;
